import React, { useState, useContext } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormGroup,
  Switch,
  FormControlLabel,
  Menu,
} from "@material-ui/core";
import mainContext from "../../context/main/mainContext";

const MarketingEmailScopes = Object.freeze({
  all: "all",
  admins: "admins",
  none: "none",
});

const MarketingEmailSettings = ({ team, member, setIsLoading }) => {
  const { updateTeamHubspotProperties, updateMemberHubspotProperties } = useContext(mainContext);
  const isMember = !!member;

  const [selectedOption, setSelectedOption] = useState(
    team?.hubspotMarketingStatus,
  );

  const [isEnabledMember, setIsEnabledMember] = useState(member?.member?.marketingContact);

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleCheckboxChange = async (e) => {
    setIsEnabledMember(e.target.checked);
    await handleSubmit(e.target.checked);
  };

  const handleSubmit = async (enabled) => {
    setIsLoading(true);
    try {
      isMember
        ? await updateMemberHubspotProperties(member?.member.id, {
          marketingEmailSettings: { enabled: enabled ?? isEnabledMember },
        })
        : await updateTeamHubspotProperties(team?.team.id, {
          marketingEmailSettings: {
            scope: selectedOption,
          },
        });
    } catch (error) {
      console.error("Error updating marketing email settings:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#f9f9f9",
        display: "flex",
        ...(!isMember && {
          margin: "1rem 0",
          border: "1px solid #e0e0e0",
          padding: "0.75rem",
        }),
        justifyContent: "space-between",
      }}
    >
      {isMember ? (
        <FormGroup style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
          <FormControlLabel
            control={
              <Switch
                checked={isEnabledMember}
                onChange={handleCheckboxChange}
                name="marketingEmailDisabled"
                inputProps={{ "aria-label": "secondary checkbox" }}
              />
            }
            label="Marketing Emails"
          />
        </FormGroup>
      ) : (
        <FormControl variant="outlined" style={{ minWidth: 200, marginRight: "1rem" }}>
          <InputLabel id="marketing-email-label">Marketing Emails</InputLabel>
          <Select
            labelId="marketing-email-label"
            value={selectedOption}
            onChange={handleChange}
            label="Marketing Emails"
          >
            <MenuItem value={MarketingEmailScopes.all}>All Members</MenuItem>
            <MenuItem value={MarketingEmailScopes.admins}>Admins Only</MenuItem>
            <MenuItem value={MarketingEmailScopes.none}>None</MenuItem>
          </Select>
        </FormControl>
      )}
      {isMember ? null : (
        <button
          type="button"
          onClick={handleSubmit}
          disabled={!selectedOption}
          style={{
            background: selectedOption ? "#2196f3" : "#ccc",
            color: "white",
            border: "none",
            borderRadius: "4px",
            padding: "6px 16px",
            fontSize: "14px",
            height: "2rem",
            alignSelf: "center",
            cursor: selectedOption ? "pointer" : "auto",
          }}
        >
          {"Save"}
        </button>
      )}
    </div>
  );
};

export default MarketingEmailSettings;
